/** Paths owned by the sign-in surface. */
const AUTH_PREFIXES = ["/signin", "/signup", "/forgot"];

/**
 * Whether a path belongs to the sign-in surface. Used by {@code App} to render
 * those pages OUTSIDE the AuthGate — gating the page we send anonymous visitors
 * to would loop forever.
 *
 * <p>Segment-aware: {@code /signups} is a different route and must not be
 * mistaken for the sign-in surface, which would render it ungated.</p>
 *
 * <p>Deliberately its own module, with no imports. {@code App} needs this
 * predicate on every render; pulling it from {@code AuthRoutes} would drag every
 * sign-in page — and the Cognito SDK behind them — into App's module graph.</p>
 */
export function isAuthPath(pathname: string): boolean {
  return AUTH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/"),
  );
}
